import api from "./api";

export const diagnosticService = {
    getActiveIssues,
    getHistoricIssues,
    getMainsSupplyEvents
};

function getActiveIssues(onlyActiveCircuits=true) {
    let url = "/cable-health-broker/v1/diagnostic/active_issues"
    if (!onlyActiveCircuits) {
        url += "?inactive=true"
      }
    return api.get(url);
}

function getHistoricIssues(page) {
    return api.get("/cable-health-broker/v1/diagnostic/historic_issues", {params: {
           limit: 25,
           skip: (page - 1) * 25
    }});
}


function getMainsSupplyEvents(page) {
    return api.get("/cable-health-broker/v1/diagnostic/mains_supply_events");
}
